window.selectEmployeeInScheduleGroup = function(elm) {
  const tr = $(elm).closest("tr")
  const target = $("#schedule-group-employee-list-selected-table")

  tr.find(".new_employee_id").removeAttr("disabled")
  tr.find(".existing_employee_status").val("active")
  $(elm).removeClass("btn-success")
  $(elm).addClass("btn-danger")
  $(elm).html("<i class='ti ti-x'></i>")
  $(elm).attr("onclick", "unselectEmployeeInScheduleGroup(this)")
  target.find("tbody").prepend(tr)
}

window.unselectEmployeeInScheduleGroup = function(elm) {
  const tr = $(elm).closest("tr")
  const target = $("#schedule-group-employee-list-selectable-table")

  tr.find(".new_employee_id").attr("disabled", "disabled")
  tr.find(".existing_employee_status").val("deleted")
  $(elm).addClass("btn-success")
  $(elm).removeClass("btn-danger")
  $(elm).html("<i class='ti ti-check'></i>")
  $(elm).attr("onclick", "selectEmployeeInScheduleGroup(this)")
  target.find("tbody").prepend(tr)
}  

document.addEventListener("DOMContentLoaded", function(){
  $(document).on('click', "#schedule-group-employee-list-save", function(){
    $('#modal-select-employee').modal('hide')
    const count = $("#schedule-group-employee-list-selected-table").find("tbody").find("tr").length
    $('#schedule-group-employee-selected-count').html(count)
  })
})